import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import ImageButton from 'components/common/Buttons/ImageButton';

const LIGHT_ME_UP = 9999;

export type Props = {
  onExitTourClick: () => void;
  nextButtonVisible: boolean;
  nextButton: any;
};

const OnboardingOverlay: React.FC<Props> = ({ onExitTourClick, nextButton, nextButtonVisible }) => {
  const { overlayDiv, exitButtonPosition } = useStyles();

  return (
    <div className={overlayDiv}>
      <ImageButton
        imageName={'rejectButton'}
        className={exitButtonPosition}
        onClick={onExitTourClick}
      />
      {nextButtonVisible && nextButton}
    </div>
  );
};

const useStyles = makeStyles(() => {
  return {
    overlayDiv: {
      display: 'block',
      width: '100%',
      height: '100%',
    },
    exitButtonPosition: {
      zIndex: LIGHT_ME_UP,
      position: 'absolute',
      top: remCalc(24),
      left: remCalc(28),
    },
  };
});

export default OnboardingOverlay;
